import { KINSHIPS_ACTIONS } from "constants/Actions/Kinships";

// Estado inicial del reducer
const aInitialState = {
    aKinships: [],
    aKinshipsList: [],

    oKinship: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los tipos de parentescos del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const KinshipReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case KINSHIPS_ACTIONS.GET:
            return { ...aState, aKinships: oAction.data };
        case KINSHIPS_ACTIONS.GET_LIST:
            return { ...aState, aKinshipsList: oAction.data };
        case KINSHIPS_ACTIONS.FIND:
            return { ...aState, oKinship: oAction.data };
        case KINSHIPS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case KINSHIPS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case KINSHIPS_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, aKinships: [] };
        default:
            return aState;
    }
}
